module.exports = function(obj) {
obj || (obj = {});
var __t, __p = '', __e = _.escape, __j = Array.prototype.join;
function print() { __p += __j.call(arguments, '') }
with (obj) {
__p += '<section class="row integrations-setup adobe-scene7-settings">\n    <section class="col-xs-4">\n        <h4>Adobe Scene7 Image Access</h4>\n        <p class="intro">With Creator\'s Adobe Scene7 Image Access you can access your assets from within the Editor and seamlessly add approved images to your Creator Experiences</p>\n    </section>\n    <section class="col-xs-4">\n        <img src="images/integration/addons/scene7/scene7-images-example.png" alt="Use your Scene7 images from the image picker in the Image Widget properties">\n    </section>\n    <section class="col-xs-4">\n        <h4>Connect your Adobe Scene7 Account</h4>\n        <p>Type or copy your company\'s Adobe Scene7 credentials into the fields below:</p>\n        ';
 if (!isManager) { ;
__p += '\n            <p class="error-message">You need to be a manager to set up this integration.</p>\n        ';
 } ;
__p += '\n        <ul class="list-unstyled">\n            <li class="form-group">\n                <label>Username</label>\n                <input type="text" name="scene7-username" placeholder="Enter Username" value="' +
__e( username ) +
'" ' +
__e( isManager ? "" : "disabled") +
' />\n            </li>\n            <li class="form-group">\n                <label>Password</label>\n                <input type="password" name="scene7-password" autocomplete="new-password" placeholder="Enter Password" ' +
__e( isManager ? "" : "disabled") +
' />\n            </li>\n            <li class="form-group">\n                <label>\n                    Company Name\n                    <p class="note">\n                        Only required if you have more than one account associated with this user\n                    </p>\n                </label>\n                <input type="text" name="companyName" placeholder="Enter Company Name" value="' +
__e( companyName ) +
'" ' +
__e( isManager ? "" : "disabled") +
' />\n            </li>\n            <li class="form-group">\n                <label>Region</label>\n                <select class="form-control" name="region" ' +
__e( isManager ? "" : "disabled") +
' >\n                    ';
 Scene7HostedRegionEnum.each(function(regionEnumOption) { ;
__p += '\n                        <option value="' +
__e( regionEnumOption.value ) +
'" ' +
__e( (regionEnumOption.value === region) ? "selected" : "" ) +
'>\n                            ' +
__e( regionEnumOption.name ) +
'\n                        </option>\n                    ';
 }) ;
__p += '\n                </select>\n            </li>\n        </ul>\n        <div class="save-button-tooltip-wrapper pull-right">\n            <button type="button" disabled="disabled" class="btn btn-primary save-adobe-scene7-credentials ladda-button" data-style="expand-right" data-spinner-size="28" disabled="disabled">\n                Save\n            </button>\n        </div>\n    </section>\n</section>\n';

}
return __p
}


//////////////////
// WEBPACK FOOTER
// ./src/editor/ui/settings/integrations/Scene7IntegrationView.tpl
// module id = 3061
// module chunks = 0